import { useRef, useCallback } from 'react';

/**
 * Score Slider — hatched-fill drag slider matching the APCS Scoring Platform prototype.
 * Supports mouse drag, keyboard arrows, and direct click positioning.
 */
const ScoreSlider = ({ value, onChange, disabled }) => {
    const ref = useRef(null);

    const setFromX = useCallback((clientX) => {
        if (!ref.current || disabled) return;
        const rect = ref.current.getBoundingClientRect();
        const pct = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
        onChange(Math.round(pct * 100));
    }, [onChange, disabled]);

    const onMouseDown = (e) => {
        if (disabled) return;
        setFromX(e.clientX);
        const move = (ev) => setFromX(ev.clientX);
        const up = () => {
            window.removeEventListener('mousemove', move);
            window.removeEventListener('mouseup', up);
        };
        window.addEventListener('mousemove', move);
        window.addEventListener('mouseup', up);
    };

    const onKey = (e) => {
        if (disabled) return;
        if (e.key === 'ArrowRight' || e.key === 'ArrowUp') { e.preventDefault(); onChange(Math.min(100, value + 1)); }
        if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') { e.preventDefault(); onChange(Math.max(0, value - 1)); }
        if (e.key === 'PageUp') { e.preventDefault(); onChange(Math.min(100, value + 10)); }
        if (e.key === 'PageDown') { e.preventDefault(); onChange(Math.max(0, value - 10)); }
        if (e.key === 'Home') { e.preventDefault(); onChange(0); }
        if (e.key === 'End') { e.preventDefault(); onChange(100); }
    };

    return (
        <div>
            <div
                ref={ref}
                className="jd-scoreslider"
                onMouseDown={onMouseDown}
                tabIndex={disabled ? -1 : 0}
                role="slider"
                aria-valuenow={value}
                aria-valuemin={0}
                aria-valuemax={100}
                onKeyDown={onKey}
                style={{ opacity: disabled ? 0.6 : 1, cursor: disabled ? 'not-allowed' : 'pointer' }}
            >
                <div className="jd-slider-fill" style={{ width: `${value}%` }} />
                <div className="jd-slider-handle" style={{ left: `${value}%` }} />
            </div>
            <div className="jd-slider-ticks">
                <span>0</span><span>25</span><span>50</span><span>75</span><span>100</span>
            </div>
        </div>
    );
};

export default ScoreSlider;
